// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login__main___tqJZx {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 80%;
    max-width: 360px;
    margin-right: -50%;
    padding: 1em;
    transform: translate(-50%, -50%);
    border-radius: 7px;
    background: rgba(0, 0, 0, 0.8);
    font-family: "IM Fell French Canon SC", serif;
    text-align: center;
}

.Login__title___qzDb6 {
    display: block;
    margin: 20px auto;
    font-size: 16px;
    letter-spacing: 0;
    text-transform: uppercase;
}

.Login__form___MOQNk {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    min-width: 260px;
    margin-top: 5px;
}

.Login__input___YXwQT {
    display: block;
    margin: 10px auto;
    font-family: "IM Fell French Canon SC", serif;
    text-align: center;
}

.Login__passkeyButton___IQBgA {
    width: 180px;
    min-height: 36px;
    margin: 10px auto;
    border: 1px solid #d9c26a;
    border-radius: 4px;
    background: rgba(217, 194, 106, 0.18);
    color: #f5e7a5;
    font-size: 13px;
    font-weight: 700;
    font-family: "IM Fell French Canon SC", serif;
    letter-spacing: 0;
    text-transform: uppercase;
    cursor: pointer;
    box-shadow: 0 0 12px rgba(217, 194, 106, 0.18);
}

.Login__passkeyButton___IQBgA:hover:not(:disabled) {
    background: rgba(217, 194, 106, 0.3);
    color: #fff3bc;
}

.Login__passkeyButton___IQBgA:disabled {
    cursor: wait;
    opacity: 0.72;
}

.Login__fallbackButton___BfNoX {
    margin: 4px auto 10px;
    border: 0;
    background: transparent;
    color: #bcae78;
    font-size: 12px;
    font-family: "IM Fell French Canon SC", serif;
    letter-spacing: 0;
    text-decoration: underline;
    cursor: pointer;
}

.Login__fallbackButton___BfNoX:hover {
    color: #eadca4;
}

.Login__passkeyUnavailable___sCQhl {
    max-width: 220px;
    color: #bcae78;
    font-size: 12px;
    font-family: "IM Fell French Canon SC", serif;
    letter-spacing: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `Login__main___tqJZx`,
	"title": `Login__title___qzDb6`,
	"form": `Login__form___MOQNk`,
	"input": `Login__input___YXwQT`,
	"passkeyButton": `Login__passkeyButton___IQBgA`,
	"fallbackButton": `Login__fallbackButton___BfNoX`,
	"passkeyUnavailable": `Login__passkeyUnavailable___sCQhl`
};
module.exports = ___CSS_LOADER_EXPORT___;
